import React from "react";
import styled from "styled-components";
import {
    BusinessPortalHeader,
    PortalCaption,
    PortalSelect,
} from "src/components";
import { TableType } from "src/constants/survey";
import pluralize from "pluralize";
import { customNames } from "src/utils/helpers";
import { getSurveyPollFeatureContext } from "./Utils";

const InputSelector = styled(PortalSelect)``;

const FilterContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: end;

    label {
        font-size: 14px;
        font-weight: 700;
        margin-right: 1em;
    }

    @media (max-width: 768px) {
        align-items: start;
        flex-direction: column;
    }
`;

const FilterRow = styled.div`
    margin: 0;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
`;

const SurveyAndPollsHeading = (props) => {
    const { handleChangeTableType, selectedTableType, user, featureContext } = props;

    const feature = featureContext || getSurveyPollFeatureContext(user?.featureFlags);
    const showDropdown = feature.options.length > 1;

    return (
        <BusinessPortalHeader
            title={feature.title}
            description={`Create focused ${feature.singularLabel}s for ${pluralize(customNames.employees.toLowerCase())} or ${pluralize(customNames.clients.toLowerCase())}, then review real-time feedback and campaign performance.`}
        >
            {showDropdown && (
                <div>
                    <PortalCaption margin="0 0 0.35rem">View mode</PortalCaption>
                    <FilterRow>
                        <FilterContainer>
                            <InputSelector width="200px" value={selectedTableType} onChange={(e) => handleChangeTableType(e.target.value)} >
                                <option value={TableType.Polls} style={{ fontSize: "1rem" }}>
                                    Polls
                                </option>
                                <option value={TableType.Surveys} style={{ fontSize: "1rem" }}>
                                    Surveys
                                </option>
                            </InputSelector>
                        </FilterContainer>
                    </FilterRow>
                </div>
            )}
        </BusinessPortalHeader>
    );
};


export default SurveyAndPollsHeading;
